import { useState, useEffect } from "react";

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // 768px es el tamaño típico de un móvil

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 910);
        };

        window.addEventListener("resize", handleResize); // Se ejecuta cuando el usuario redimensiona
        
        return () => window.removeEventListener("resize", handleResize); // Cleanup cuando el componente se desmonta
    }, []); // Se ejecuta solo una vez al montar
    
    return isMobile;
};

export default useIsMobile;